import alt from '../alt';
import CurrentUserActions from '../actions/CurrentUserActions';
import SingleObjectResource from '../resources/GenericResource';


class BillingDetailsActions {
    constructor() {
        this.generateActions('getBillingDetailsSuccess', 'getBillingDetailsFailed', 'clearBillingDetailsData');
    }

    updateBillingDetails(billingDetails) {
        new SingleObjectResource(DJ_CONST.API.myBillingDetails).patch({}, billingDetails).then(result => {
            this.dispatch(result);
        }).catch(err => this.actions.failUpdateBillingDetails(err));
    }

    failUpdateBillingDetails(updateError) {
        if (updateError.statusCode === 400){
            this.dispatch({updateError});
        } else {
            return CurrentUserActions.pageFault(updateError);
        }
    }
}

export default alt.createActions(BillingDetailsActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/BillingDetailsActions.js
 **/